(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-hero-description')) {
    customElements.define(
      'collection-hero-description',
      class CollectionHeroDescription extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;

          this.dataset.initialized = 'true';
          this.description = this.querySelector('[data-collection-hero-description-content]');
          this.toggleButton = this.querySelector('[data-collection-hero-description-toggle]');

          if (!this.description || !this.toggleButton) return;

          this.handleToggle = () => {
            const isExpanded = this.dataset.expanded === 'true';
            const willExpand = !isExpanded;
            this.dataset.expanded = String(willExpand);
            this.toggleButton.setAttribute('aria-expanded', String(willExpand));

            if (!willExpand) {
              this.checkOverflow();
            }
          };

          this.toggleButton.addEventListener('click', this.handleToggle);
          this.resizeObserver = new ResizeObserver(() => this.checkOverflow());
          this.resizeObserver.observe(this);
          requestAnimationFrame(() => this.checkOverflow());
        }

        disconnectedCallback() {
          this.toggleButton?.removeEventListener('click', this.handleToggle);
          this.resizeObserver?.disconnect();
        }

        checkOverflow() {
          if (!this.description || !this.toggleButton || this.dataset.expanded === 'true') return;

          this.dataset.collapsible = 'true';
          this.toggleButton.hidden = false;

          requestAnimationFrame(() => {
            const hasOverflow = this.description.scrollHeight > this.description.clientHeight + 1;
            this.dataset.collapsible = String(hasOverflow);
            this.toggleButton.hidden = !hasOverflow;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-masonry"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const gridSelector = '[data-image-masonry-grid]';

    function normalizeLogos(grid) {
      grid.querySelectorAll('.theme-image-masonry__image').forEach((image) => {
        const visual = image.closest('.theme-image-masonry__visual');
        const availableWidth = visual?.clientWidth || 0;
        const imageRatio = image.naturalWidth / image.naturalHeight;

        if (!availableWidth || !Number.isFinite(imageRatio) || imageRatio <= 0) return;

        const targetHeight = Math.min(64, Math.max(44, availableWidth * 0.26));
        const targetArea = availableWidth * targetHeight;
        let targetWidth = Math.sqrt(targetArea * imageRatio);
        const calculatedHeight = targetWidth / imageRatio;
        const maxHeight = Number.parseFloat(window.getComputedStyle(image).maxHeight) || calculatedHeight;
        const scale = Math.min(1, availableWidth / targetWidth, maxHeight / calculatedHeight);

        targetWidth *= scale;
        image.style.width = `${targetWidth}px`;
      });
    }

    function layoutGrid(grid) {
      if (!grid?.matches(gridSelector)) return;

      const items = Array.from(grid.querySelectorAll('.theme-image-masonry__item'));

      normalizeLogos(grid);

      items.forEach((item) => {
        item.style.gridRowEnd = 'auto';
        item.style.gridColumnStart = 'auto';
      });

      const renderedColumns = window.getComputedStyle(grid).gridTemplateColumns.split(' ').length;
      const columnCount = Math.max(1, Math.round(renderedColumns / 2));
      const finalRowCount = items.length % columnCount;

      if (finalRowCount > 0) {
        const finalRowStart = columnCount - finalRowCount + 1;

        items.slice(-finalRowCount).forEach((item, index) => {
          item.style.gridColumnStart = String(finalRowStart + (index * 2));
        });
      }

      const rowHeight = Number.parseFloat(window.getComputedStyle(grid).gridAutoRows);
      if (!Number.isFinite(rowHeight) || rowHeight <= 0) return;

      items.forEach((item) => {
        const itemStyles = window.getComputedStyle(item);
        const itemHeight = item.getBoundingClientRect().height;
        const marginBottom = Number.parseFloat(itemStyles.marginBottom) || 0;
        const rowSpan = Math.max(1, Math.ceil((itemHeight + marginBottom) / rowHeight));

        item.style.gridRowEnd = `span ${rowSpan}`;
      });
    }

    function initGrid(grid) {
      if (!grid || grid.dataset.imageMasonryInitialized === 'true') return;
      grid.dataset.imageMasonryInitialized = 'true';

      let layoutFrame;
      const scheduleLayout = () => {
        window.cancelAnimationFrame(layoutFrame);
        layoutFrame = window.requestAnimationFrame(() => layoutGrid(grid));
      };

      grid.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', scheduleLayout, { once: true });
      });

      if (typeof ResizeObserver === 'function') {
        let previousGridWidth = 0;
        const resizeObserver = new ResizeObserver(([entry]) => {
          const nextGridWidth = entry?.contentRect?.width || 0;
          if (Math.abs(nextGridWidth - previousGridWidth) < 0.5) return;

          previousGridWidth = nextGridWidth;
          scheduleLayout();
        });
        resizeObserver.observe(grid);
        grid.__pegasusImageMasonryResizeObserver = resizeObserver;
      } else {
        window.addEventListener('resize', scheduleLayout, { passive: true });
      }

      scheduleLayout();
    }

    function initImageMasonry(root = document) {
      if (root.matches?.(gridSelector)) initGrid(root);
      root.querySelectorAll?.(gridSelector).forEach(initGrid);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initImageMasonry(), { once: true });
    } else {
      initImageMasonry();
    }

    document.addEventListener('shopify:section:load', (event) => initImageMasonry(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-bento-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const key = '__pegasusScrollBentoGallery';
    const state = window[key] || {
      instances: new Map(),
      raf: null,
      resizeRaf: null,
      initialized: false,
      reduceMotionQuery: window.matchMedia('(prefers-reduced-motion: reduce)'),
      desktopQuery: window.matchMedia('(min-width: 768px)'),
    };

    window[key] = state;
    state.reduceMotionQuery = state.reduceMotionQuery || window.matchMedia('(prefers-reduced-motion: reduce)');
    state.desktopQuery = state.desktopQuery || window.matchMedia('(min-width: 768px)');

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const getViewportHeight = () => (
      (window.visualViewport && window.visualViewport.height)
      || window.innerHeight
      || document.documentElement.clientHeight
      || 0
    );
    const getViewportWidth = () => (
      (window.visualViewport && window.visualViewport.width)
      || window.innerWidth
      || document.documentElement.clientWidth
      || 0
    );

    const scheduleUpdate = () => {
      if (state.raf) return;

      state.raf = requestAnimationFrame(() => {
        state.raf = null;
        state.instances.forEach((instance) => instance.update());
      });
    };

    const scheduleMeasure = () => {
      if (state.resizeRaf) cancelAnimationFrame(state.resizeRaf);

      state.resizeRaf = requestAnimationFrame(() => {
        state.resizeRaf = null;
        state.instances.forEach((instance) => instance.measure());
      });
    };

    const setupSection = (section) => {
      if (!section || state.instances.has(section)) return;

      const stage = section.querySelector('[data-scroll-bento-stage]');
      const viewport = section.querySelector('[data-scroll-bento-viewport]');
      const grid = section.querySelector('[data-scroll-bento-grid]');
      const measureContainer = section.querySelector('[data-scroll-bento-container-measure]');
      const tiles = Array.from(section.querySelectorAll('[data-scroll-bento-tile]'));

      if (!stage || !viewport || !grid || tiles.length < 2) return;

      const focalIndex = Number.parseInt(section.dataset.scrollBentoFocalTile, 10) - 1;
      const focalWidthMode = section.dataset.scrollBentoFocalWidth || 'container';

      const instance = {
        transforms: [],
        reduced: false,
        clear() {
          grid.classList.remove('is-final-layout', 'is-absolute-layout');
          grid.style.clipPath = '';
          tiles.forEach((tile) => {
            tile.style.transform = '';
            tile.style.width = '';
            tile.style.height = '';
            tile.style.opacity = '';
            tile.style.zIndex = '';
            tile.style.removeProperty('--scroll-bento-image-scale');
          });
        },
        measure() {
          this.reduced = state.reduceMotionQuery.matches;
          this.transforms = [];
          this.clipBottomFinal = 0;
          this.mobileStickyTop = 0;
          this.mobileScrubDistance = 1;
          this.clear();

          if (this.reduced) return;

          const isDesktop = state.desktopQuery.matches;
          const gridRect = grid.getBoundingClientRect();
          const viewportRect = viewport.getBoundingClientRect();
          const containerRect = measureContainer ? measureContainer.getBoundingClientRect() : gridRect;
          const firstRects = tiles.map((tile) => tile.getBoundingClientRect());
          const gridStyle = getComputedStyle(grid);
          const finalGap = parseFloat(gridStyle.columnGap || gridStyle.gap) || 8;
          const viewportLeft = viewportRect.left - gridRect.left;
          const viewportTop = viewportRect.top - gridRect.top;
          const screenWidth = getViewportWidth() || viewportRect.width;
          const screenHeight = getViewportHeight() || viewportRect.height;
          const mobileStickyTop = isDesktop ? 0 : Math.max(0, screenHeight - viewportRect.height);

          this.mobileStickyTop = mobileStickyTop;
          this.mobileScrubDistance = Math.max(1, mobileStickyTop || screenHeight);

          const hasFocal = (
            Number.isFinite(focalIndex)
            && focalIndex >= 0
            && focalIndex < firstRects.length
            && viewportRect.width > 0
            && viewportRect.height > 0
          );

          const aspectFor = (tile, rect) => {
            const rawAspect = Number.parseFloat(tile.dataset.scrollBentoAspectRatio || '');
            if (Number.isFinite(rawAspect) && rawAspect > 0) return rawAspect;
            return rect.height > 0 ? rect.width / rect.height : 1.5;
          };

          const areaFor = (index) => {
            const desktopAreas = [
              { column: 0, row: 0, columnSpan: 1, rowSpan: 2 },
              { column: 1, row: 0, columnSpan: 1, rowSpan: 1 },
              { column: 1, row: 1, columnSpan: 1, rowSpan: 2 },
              { column: 2, row: 0, columnSpan: 1, rowSpan: 2 },
              { column: 0, row: 2, columnSpan: 1, rowSpan: 1 },
              { column: 2, row: 2, columnSpan: 1, rowSpan: 2 },
              { column: 0, row: 3, columnSpan: 1, rowSpan: 1 },
              { column: 1, row: 3, columnSpan: 1, rowSpan: 1 },
            ];

            return desktopAreas[index] || {
              column: index % 3,
              row: Math.floor(index / 3),
              columnSpan: 1,
              rowSpan: 1,
            };
          };

          grid.classList.add('is-final-layout');
          const finalRects = tiles.map((tile) => tile.getBoundingClientRect());
          grid.classList.remove('is-final-layout');

          let targetRects = null;

          if (hasFocal) {
            const areas = tiles.map((tile, index) => areaFor(index));
            const focalArea = areas[focalIndex];

            if (isDesktop) {
              const focalFirst = firstRects[focalIndex];
              const focalAspect = aspectFor(tiles[focalIndex], focalFirst);
              const maxContainerWidth = focalWidthMode === 'viewport' ? viewportRect.width : containerRect.width;
              let focalWidth = Math.min(maxContainerWidth || viewportRect.width, viewportRect.width - (finalGap * 2));
              let focalHeight = focalWidth / focalAspect;

              if (focalHeight > viewportRect.height * 0.92) {
                focalHeight = viewportRect.height * 0.92;
                focalWidth = focalHeight * focalAspect;
              }

              const focalX = viewportLeft + ((viewportRect.width - focalWidth) / 2);
              const focalY = viewportTop + ((viewportRect.height - focalHeight) / 2);
              const finalColumnWidth = Math.max(1, (focalWidth - (finalGap * (focalArea.columnSpan - 1))) / focalArea.columnSpan);
              const finalRowHeight = Math.max(1, (focalHeight - (finalGap * (focalArea.rowSpan - 1))) / focalArea.rowSpan);
              const finalGridX = focalX - (focalArea.column * (finalColumnWidth + finalGap));
              const finalGridY = focalY - (focalArea.row * (finalRowHeight + finalGap));
              this.clipBottomFinal = Math.max(0, (viewportTop + viewportRect.height) - (focalY + focalHeight));

              targetRects = areas.map((area) => ({
                x: finalGridX + (area.column * (finalColumnWidth + finalGap)),
                y: finalGridY + (area.row * (finalRowHeight + finalGap)),
                width: (area.columnSpan * finalColumnWidth) + ((area.columnSpan - 1) * finalGap),
                height: (area.rowSpan * finalRowHeight) + ((area.rowSpan - 1) * finalGap),
              }));
            } else {
              const columnCount = Math.max(3, ...areas.map((area) => area.column + area.columnSpan));
              const rowCount = Math.max(1, ...areas.map((area) => area.row + area.rowSpan));
              const columnWeights = Array.from({ length: columnCount }, (item, index) => (
                index === 0 ? 1 : index === 1 ? 3 : index === 2 ? 1 : 1
              ));
              const totalColumnWeight = columnWeights.reduce((sum, weight) => sum + weight, 0);
              const finalGridWidth = Math.max(1, screenWidth);
              const finalGridHeight = Math.max(1, screenHeight);
              const finalColumnWidth = Math.max(1, finalGridWidth - (finalGap * (columnCount - 1)));
              const finalRowHeight = Math.max(1, (finalGridHeight - (finalGap * (rowCount - 1))) / rowCount);
              const columnWidths = columnWeights.map((weight) => finalColumnWidth * (weight / totalColumnWeight));
              const columnOffsets = columnWidths.reduce((offsets, width, index) => {
                offsets.push(index === 0 ? 0 : offsets[index - 1] + columnWidths[index - 1] + finalGap);
                return offsets;
              }, []);
              const finalGridX = -gridRect.left;
              const finalGridY = -mobileStickyTop;
              this.clipBottomFinal = 0;

              targetRects = areas.map((area) => {
                const spannedColumns = columnWidths.slice(area.column, area.column + area.columnSpan);
                const width = spannedColumns.reduce((sum, columnWidth) => sum + columnWidth, 0) + (finalGap * (area.columnSpan - 1));

                return {
                  x: finalGridX + columnOffsets[area.column],
                  y: finalGridY + (area.row * (finalRowHeight + finalGap)),
                  width,
                  height: (area.rowSpan * finalRowHeight) + ((area.rowSpan - 1) * finalGap),
                };
              });
            }
          }

          this.transforms = tiles.map((tile, index) => {
            const first = firstRects[index];
            const final = finalRects[index];
            const target = targetRects && targetRects[index];
            const x2 = target ? target.x : final.left - gridRect.left;
            const y2 = target ? target.y : final.top - gridRect.top;
            const width2 = target ? target.width : final.width;
            const height2 = target ? target.height : final.height;
            let zIndex = index === focalIndex ? 3 : 1;

            return {
              x1: first.left - gridRect.left,
              y1: first.top - gridRect.top,
              width1: first.width,
              height1: first.height,
              x2,
              y2,
              width2,
              height2,
              opacity1: 1,
              opacity2: 1,
              imageScale1: isDesktop ? 1 : (index === focalIndex ? 1.18 : 1.1),
              imageScale2: isDesktop ? 1 : (index === focalIndex ? 1 : 1.04),
              zIndex,
            };
          });

          grid.classList.add('is-absolute-layout');
          this.update();
        },
        update() {
          if (this.reduced || !this.transforms.length) return;

          const isDesktop = state.desktopQuery.matches;
          const distance = Math.max(1, stage.offsetHeight - viewport.offsetHeight);
          const stageTop = stage.getBoundingClientRect().top;
          const progress = isDesktop
            ? clamp(-stageTop / distance, 0, 1)
            : clamp(((this.mobileStickyTop || 0) - stageTop) / (this.mobileScrubDistance || 1), 0, 1);
          const clipProgress = clamp((progress - 0.72) / 0.28, 0, 1);
          const clipBottom = this.clipBottomFinal ? this.clipBottomFinal * clipProgress : 0;

          grid.style.clipPath = clipBottom > 0.5 ? `inset(0px 0px ${clipBottom}px 0px)` : '';

          tiles.forEach((tile, index) => {
            const transform = this.transforms[index];
            if (!transform) return;

            const x = transform.x1 + ((transform.x2 - transform.x1) * progress);
            const y = transform.y1 + ((transform.y2 - transform.y1) * progress);
            const width = transform.width1 + ((transform.width2 - transform.width1) * progress);
            const height = transform.height1 + ((transform.height2 - transform.height1) * progress);
            const opacity = transform.opacity1 + ((transform.opacity2 - transform.opacity1) * progress);
            const imageScale = transform.imageScale1 + ((transform.imageScale2 - transform.imageScale1) * progress);

            tile.style.width = `${width}px`;
            tile.style.height = `${height}px`;
            tile.style.opacity = opacity.toFixed(3);
            tile.style.zIndex = transform.zIndex;
            tile.style.setProperty('--scroll-bento-image-scale', imageScale.toFixed(4));
            tile.style.transform = `translate3d(${x}px, ${y}px, 0)`;
          });
        },
        destroy() {
          this.clear();
          state.instances.delete(section);
        },
      };

      state.instances.set(section, instance);

      section.querySelectorAll('img').forEach((image) => {
        if (image.complete) return;
        image.addEventListener('load', scheduleMeasure, { once: true });
      });

      instance.measure();
    };

    const setupAll = () => {
      document.querySelectorAll('[data-scroll-bento-gallery]').forEach((section) => setupSection(section));
    };

    if (!state.initialized) {
      state.initialized = true;

      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleMeasure);
      if (state.reduceMotionQuery.addEventListener) {
        state.reduceMotionQuery.addEventListener('change', scheduleMeasure);
      } else if (state.reduceMotionQuery.addListener) {
        state.reduceMotionQuery.addListener(scheduleMeasure);
      }

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.matches && event.target.matches('[data-scroll-bento-gallery]')) {
          setupSection(event.target);
        }

        event.target.querySelectorAll('[data-scroll-bento-gallery]').forEach((section) => setupSection(section));
      });

      document.addEventListener('shopify:section:unload', (event) => {
        state.instances.forEach((instance, section) => {
          if (event.target === section || event.target.contains(section)) {
            instance.destroy();
          }
        });
      });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupAll, { once: true });
      }
    }

    if (!state.desktopQueryListenerInitialized) {
      state.desktopQueryListenerInitialized = true;

      if (state.desktopQuery.addEventListener) {
        state.desktopQuery.addEventListener('change', scheduleMeasure);
      } else if (state.desktopQuery.addListener) {
        state.desktopQuery.addListener(scheduleMeasure);
      }
    }

    setupAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonials-slider')) {
    customElements.define('testimonials-slider', class TestimonialsSlider extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.track = this.querySelector('[data-testimonials-track]');
        this.slides = [...this.querySelectorAll('[data-testimonial-slide]')];
        this.previousButton = this.querySelector('[data-testimonials-prev]');
        this.nextButton = this.querySelector('[data-testimonials-next]');
        this.pagination = this.querySelector('[data-testimonials-pagination]');
        this.status = this.querySelector('[data-testimonials-status]');
        this.pageIndex = 0;
        this.pointerStart = null;
        if (!this.track || this.slides.length === 0) return;
        this.previousButton?.addEventListener('click', () => this.goTo(this.pageIndex - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.pageIndex + 1));
        this.track.addEventListener('keydown', (event) => { if (['ArrowLeft','ArrowRight'].includes(event.key)) { event.preventDefault(); this.goTo(this.pageIndex + (event.key === 'ArrowRight' ? 1 : -1)); } });
        this.track.addEventListener('pointerdown', (event) => { this.pointerStart = event.clientX; });
        this.track.addEventListener('pointerup', (event) => { if (this.pointerStart === null) return; const distance = event.clientX - this.pointerStart; this.pointerStart = null; if (Math.abs(distance) > 40) this.goTo(this.pageIndex + (distance < 0 ? 1 : -1)); });
        this.addEventListener('shopify:block:select', (event) => { const index = this.slides.indexOf(event.target.closest('[data-testimonial-slide]')); if (index >= 0) this.goTo(Math.floor(index / this.cardsPerPage())); });
        window.addEventListener('resize', () => { cancelAnimationFrame(this.resizeFrame); this.resizeFrame = requestAnimationFrame(() => this.update(true)); }, { passive: true });
        this.update(true);
      }
      cardsPerPage() { return window.matchMedia('(min-width: 768px)').matches ? 3 : 1; }
      pageCount() { return Math.max(1, Math.ceil(this.slides.length / this.cardsPerPage())); }
      goTo(index) { const count = this.pageCount(); this.pageIndex = (index + count) % count; this.update(); }
      update(rebuildPagination = false) {
        const perPage = this.cardsPerPage();
        const count = this.pageCount();
        this.pageIndex = Math.min(this.pageIndex, count - 1);
        const first = this.pageIndex * perPage;
        const target = this.slides[first] || this.slides[0];
        this.track.style.transform = `translate3d(${-target.offsetLeft}px,0,0)`;
        this.slides.forEach((slide,index) => { const visible = index >= first && index < first + perPage; slide.setAttribute('aria-hidden', visible ? 'false' : 'true'); slide.toggleAttribute('inert', !visible); });
        if (this.pagination && (rebuildPagination || this.pagination.children.length !== count)) {
          this.pagination.replaceChildren();
          for (let index = 0; index < count; index += 1) { const button = document.createElement('button'); button.type = 'button'; button.className = 'theme-testimonials__pagination-button'; button.setAttribute('aria-label', `Go to testimonial page ${index + 1}`); button.addEventListener('click', () => this.goTo(index)); this.pagination.append(button); }
        }
        [...(this.pagination?.children || [])].forEach((button,index) => button.setAttribute('aria-current', index === this.pageIndex ? 'true' : 'false'));
        const hidden = count <= 1;
        if (this.previousButton) this.previousButton.hidden = hidden;
        if (this.nextButton) this.nextButton.hidden = hidden;
        if (this.pagination) this.pagination.hidden = hidden;
        if (this.status) this.status.textContent = `Testimonials page ${this.pageIndex + 1} of ${count}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
